export const removeDashes = (str: string): string => {
  return str.replace(/-/g, '');
};

export const toExternalId = (uuid: string | undefined | null): string | undefined => {
  return uuid ? removeDashes(uuid).toLowerCase() : undefined;
};
